import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/", { replace: true });
      return;
    }
    const session_id = match[1];

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id });
        setUser(res.data.user);
        // Clear hash and go to library
        window.history.replaceState(null, "", window.location.pathname);
        nav("/library", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        console.error(e);
        nav("/?auth_error=1", { replace: true });
      }
    })();
  }, [nav, setUser, location]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-black text-white grain" data-testid="auth-callback">
      <Logo inverted size={36} />
      <div className="mt-8 flex items-center gap-3 text-sm text-white/60">
        <span className="w-2 h-2 bg-[#E60000] animate-pulse" />
        Establishing your squad session…
      </div>
    </div>
  );
}
